module.exports = function() {
  return new Worker(__webpack_public_path__ + "71946988bef7f776d819.worker.js");
};